import React from "react";

import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { format } from "@/utils/datetime";
import { apply } from "@/utils/functions";

import { formatBytes } from "../utils/helpers";

export interface MessageMetaProps {
  createdAt: Date | string;
  editedAt?: string | null;
  isSent: boolean;
  isRead: boolean;
  fileSize?: number;
}

const useStyles = makeStyles()((theme) => ({
  timestamp: {
    fontSize: 14,
    lineHeight: "18px",
    color: "#8D98A0",
  },
  indicators: {
    marginLeft: theme.spacing(1),
    display: "flex",
    fontSize: 14,
    lineHeight: "18px",
    alignItems: "baseline",
    color: "#8D98A0",
  },
  sentIcon: {
    alignSelf: "center",
  },
}));

const MessageMeta: React.FC<MessageMetaProps> = ({
  createdAt,
  editedAt,
  isSent,
  isRead,
  fileSize,
}) => {
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Typography className={classes.timestamp}>
        {apply(fileSize, (bytes) => `${formatBytes(bytes)} • `)}
        {format({ datetime: createdAt }, "MM/dd/yy p")} {editedAt && '(Edited)'}
      </Typography>
      <Box className={classes.indicators}>
        {isSent && (
          <DoneAllIcon className={classes.sentIcon} fontSize="inherit" />
        )}
        {isRead && <span>R</span>}
      </Box>
    </Box>
  );
};

export default MessageMeta;
